import React from "react";

import { Chip, Stack, Typography } from "@mui/material";
import HubHoverInfo from "../../components/HubHoverInfo/HubHoverInfo";

const PartialCell = ({ item }) => (
  <Stack direction="row" alignItems="center" gap="5px">
    <Typography fontSize={12} variant="caption" lineHeight="12px">
      {item?.isPartial ? item?.available : item.routeQuantity}
    </Typography>
    {(item.isPartial || item.isSubRoute) && (
      <Typography
        variant="captionMainBold"
        lineHeight="10px"
        sx={{
          fontSize: 10,
          fontWeight: 500,
          padding: "3px",
          border: "1px solid",
          borderColor: "hubColors.mainFocus",
          borderRadius: "3px",
          marginLeft: "auto",
        }}
      >
        {item.isSubRoute ? "Subroute" : "Partial"}
      </Typography>
    )}
  </Stack>
);

export default PartialCell;
